// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-name {
  position: relative;
  letter-spacing: -0.02em;
  font-size: 24px !important;
  line-height: 150%;
  font-weight: 800 !important;
  text-align: center;
  width: 100%; /* Ensure full width for centering */
}
@media (max-width: 925px) {
  .game-name {
    font-size: 18px !important;
    font-weight: 800 !important;
  }
}

.parties {
  text-decoration: none;
  height: 12px;
  position: relative;
  font-weight: 700 !important;
  color: inherit;
  display: inline-block;
  min-width: 70px;
}

.game-name-and-parties-container,
.parties-container {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: flex-start; /* Align left */
}

.parties-container {
  flex-direction: row;
  padding: 0 51px;
  text-align: center;
  font-size: 16px;
  color: #002129;
}

.game-name-and-parties-container {
  width: 100%;
  flex-direction: column;
  gap: 8px;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  font-size: 18px;
  color: #000;
  font-family: Inter;
  align-items: center; /* Center horizontally */
}

.bracket-box-header {
  width: 100%;
  background: #F2F2F2;
  height: 257px;
  border-top: 8px solid #FFC60A;
  border-bottom: 8px solid #FFC60A;
}
@media (max-width: 925px) {
  .bracket-box-header {
    height: 87px;
    border-top: 4px solid #FFC60A;
    border-bottom: 4px solid #FFC60A;
  }
}

.pick-em-header-headings {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-decoration-line: underline;
  font-size: 14px !important;
}
@media (max-width: 925px) {
  .pick-em-header-headings {
    font-size: 10px !important;
    font-weight: 800;
  }
}

.pick-em-header-values {
  color: #4A4A4A;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 16px !important;
}
@media (max-width: 925px) {
  .pick-em-header-values {
    font-size: 12px !important;
    font-weight: 700;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MyPoolsPage/MyPoolsPage.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA,EAAA,oCAAA;AALF;AAOE;EATF;IAUI,0BAAA;IACA,2BAAA;EAJF;AACF;;AAQE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AALJ;;AAQE;;EAEE,aAAA;EACA,mBAAA,EAAA,sBAAA;EACA,2BAAA,EAAA,eAAA;AALJ;;AAQE;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AALJ;;AAQE;EACE,WAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA,EAAA,wBAAA;AALJ;;AAsBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,gCAAA;AAnBF;AAoBE;EANF;IAOI,YAAA;IACA,6BAAA;IACA,gCAAA;EAjBF;AACF;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,0BAAA;AAlBF;AAoBE;EAVF;IAWI,0BAAA;IACA,gBAAA;EAjBF;AACF;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAlBF;AAoBE;EATF;IAUI,0BAAA;IACA,gBAAA;EAjBF;AACF","sourcesContent":["$breakpoint-xs: 480px;\n$breakpoint-sm: 768px;\n$breakpoint-md: 925px;\n$breakpoint-lg: 1366px;\n\n\n.game-name {\n  position: relative;\n  letter-spacing: -0.02em;\n  font-size: 24px !important;\n  line-height: 150%;\n  font-weight: 800 !important;\n  text-align: center;\n  width: 100%; /* Ensure full width for centering */\n\n  @media (max-width: $breakpoint-md) {\n    font-size: 18px !important;  // Smaller font size on smaller screens\n    font-weight: 800 !important;\n  }\n}\n\n  \n  .parties {\n    text-decoration: none;\n    height: 12px;\n    position: relative;\n    font-weight: 700 !important;\n    color: inherit;\n    display: inline-block;\n    min-width: 70px;\n  }\n  \n  .game-name-and-parties-container,\n  .parties-container {\n    display: flex;\n    align-items: center; /* Center vertically */\n    justify-content: flex-start; /* Align left */\n  }\n  \n  .parties-container {\n    flex-direction: row;\n    padding: 0 51px;\n    text-align: center;\n    font-size: 16px;\n    color: #002129;\n  }\n  \n  .game-name-and-parties-container {\n    width: 100%;\n    flex-direction: column;\n    gap: 8px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: left;\n    font-size: 18px;\n    color: #000;\n    font-family: Inter;\n    align-items: center; /* Center horizontally */\n  }\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.bracket-box-header{\n  width: 100%;\n  background: #F2F2F2;\n  height:257px;\n  border-top: 8px solid #FFC60A;\n  border-bottom: 8px solid #FFC60A;\n  @media (max-width: $breakpoint-md) {\n    height:87px;\n    border-top: 4px solid #FFC60A;\n    border-bottom: 4px solid #FFC60A;\n  }\n}\n\n\n.pick-em-header-headings {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  text-decoration-line: underline;\n  font-size: 14px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 10px !important;  // Smaller font size on smaller screens\n    font-weight: 800;\n\n  }\n}\n\n.pick-em-header-values {\n  color: #4A4A4A;\n  text-align: center;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  font-size: 16px !important;\n\n  @media (max-width: $breakpoint-md) {  // Uses variable for breakpoint\n    font-size: 12px !important;  // Smaller font size on smaller screens\n    font-weight: 700;\n\n  }\n}\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
